import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { AppAndNames, AppsService } from '../../../../../../data-services/apps.service';
import { DynamicOptionsComponent } from '../dynamic-options';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-account-options',
  templateUrl: './account-options.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class AccountOptionsComponent implements OnInit, DynamicOptionsComponent {
  accountControl: UntypedFormControl = new UntypedFormControl(null, accountValidator);

  /**
   * The list of products available to this partner. As the list is populated,
   * it retrieves the product names.
   * @see accountsById$
   */
  accounts$: Observable<AppAndNames[]> = this.appService.getProductNames(true, false, true).pipe(
    take(1),
    tap((apps) => {
      this.accountsSortedByName = apps.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      this.accountsSortedByName.forEach((app) => this.accountsById$.set(app.appId, app.name));
      this.areNamesLoaded$$.next(true);
    }),
  );

  /** The accounts visible to the partner keyed by their ID.*/
  accountsById$ = new Map<string, string>();

  /** The list of accounts sorted by name. */
  accountsSortedByName: Array<AppAndNames> = [];
  @Input() initialValue: string[];
  selectedValue$ = this.accountControl.valueChanges;

  /** Receives an event when all app names are loaded and ready for display. */
  areNamesLoaded$$: Subject<boolean> = new ReplaySubject();
  areNamesLoaded$ = this.areNamesLoaded$$.asObservable();

  constructor(private appService: AppsService) {}

  ngOnInit(): void {
    if (Array.isArray(this.initialValue)) {
      this.accountControl.setValue(this.initialValue);
    }
    this.accounts$.subscribe();
  }

  getSelectedValue(): string {
    return this.accountControl?.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.accountControl];
  }

  isFormValid(): boolean {
    return this.accountControl.valid;
  }
}

function accountValidator(control: AbstractControl): { [key: string]: any } {
  return Array.isArray(control.value) && control.value.length > 0 ? null : { error: false };
}
